/*
Suresh Peddavoora 01/25/2023 2698964415 Field Value Autocomplete Alignments
Suresh Peddavoora 02/24/2023 2698964415 New UI changes

Sohel 02/28/2023 2698964415 Field Value changes
Sohel 03/09/2023 2698964415 Fixed page break issue
Sohel 03/17/2023 2698964415 add delete icon for default filter
Dilip 03/28/2023 2698964415 fixed condition dropdown values issue.
Sohel 04/13/2023 2698964415 Added Type Field in Filter Criteria
Prakash 20/04/2023 2698964415 fixed alignment issue for input filed
Akhila 06/05/2023 2698964415 removed condition on between and not between
Akhila 06/12/2023 2698964415 added role access
Sohel 10/11/2023 2698964415 Duplicate Criteria SQL Output Changes
*/
import {IconButton, TextField, Tooltip} from '@material-ui/core';
import React from 'react';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import GuiTextField from '../FormComponents/GuiTextField';
import reusableInputStyles from '../InputStyles';
import {generateSql, GetFields, getOptions} from './filterUtils';
import {withField} from './withField';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import {ErrorMessage} from './ErrorMessage';
import {getIn} from 'formik';

export const typeOptions = [
  {label: 'Field', value: 'file'},
  {label: 'Value', value: 'value'},
];

export const typeOptions2 = [{label: 'Field', value: 'file'}];
export const hideValuesConditions = ['isBlank', 'isNotBlank'];
const SqlRuleBuilder = (props) => {
  const {
    name,
    value: current,
    setFieldValue,
    fields = [],
    handleDelete,
    errors,
    touched,
    handleBlur,
    mappedFieldsData = [],
    isReports = false,
    dmTempRecordAccess,
    editExisting,
  } = props;
  const classes = reusableInputStyles();
  const handleChange = (property, value) => {
    const copy = {...current};
    copy[property] = value;
    if (property === 'field') {
      copy['condition'] = '';
      copy['value'] = '';
      copy['value1'] = '';
      copy['sqlValue'] = '';
    }
    if (property === 'condition' || property === 'type') {
      if (current.field.fieldType.toLowerCase() === 'date') {
        copy['value'] = '';
        copy['valu1'] = '';
        copy['value1'] = '';
        copy['valu1'] = '';
      } else {
        copy['value'] = '';
        copy['valu1'] = '';
      }
    }
    generateSql(copy);
    setFieldValue(name, copy);
  };

  React.useEffect(() => {
    name && setFieldValue && setFieldValue(name, current);
  }, [name, current, setFieldValue]);

  const getError = (name) => getIn(touched, name) && getIn(errors, name);
  const showSqlOutput =
    (current.condition &&
      (current.condition.value === 'isBlank' || current.condition.value === 'isNotBlank')) ||
    (current.condition && current.sqlValue && (current.value || current.value1));
  return (
    <div className="sql-builder-section global-field-textfields">
      <div className="rulecode-section">
        <span>{current.ruleCode}</span>
      </div>
      {isReports ? (
        <>
          <div className="col-md-4 col-lg-2 form-group">
            <TextField
              fullWidth
              margin="dense"
              value={current.field.repositoryName}
              label="Repository"
            />
          </div>
          <div className="col-md-4 col-lg-2 form-group">
            <TextField fullWidth margin="dense" value={current.field.fieldName} label="Field" />
          </div>
        </>
      ) : (
        <div className="col-md-4 col-lg-3 form-group">
          {/* <ErrorTooltip title={getIn(errors, `${name}.field`) || null}> */}
          <GuiAutoComplete
            classes={{
              popper: classes.popper,
              option: classes.option,
            }}
            id="field"
            value={current.field ? current.field : ''}
            options={fields ? fields : []}
            size="small"
            autoHighlight
            name={`${name}.field`}
            //   value={fieldListData.globalFieldsList}
            //   getOptionDisabled={(option) => option?.fieldCode === null}
            getOptionLabel={(option) => {
              return option && option?.fieldName ?
                `${option?.repository} - ${option?.fieldName}` :
                '';
            }}
            renderInput={(params) => (
              <GuiTextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                // className={` ${classes.labelName} ${classes.selectLabel}`}
                // variant="outlined"
                fullWidth
                onBlur={handleBlur}
                margin="dense"
                label="Field"
                error={getError(`${name}.field`)}
                name={`${name}.field`}
                placeholder="Select field"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off',
                }}
              />
            )}
            onChange={(_, data) => {
              handleChange('field', data);
              //   handleUpdateRule(index, "field", data);
            }}
          />
          {/* </ErrorTooltip> */}
          <ErrorMessage
            render={(msg) => (
              <div className={msg ? `error-text rule-bulider-error` : ``}>{msg}</div>
            )}
            name={`sqlRules[${props.index}].field`}
          />
        </div>
      )}

      {current.field && (
        <>
          <div className="col-md-4 col-lg-2 form-group sqlAutocomplete-input">
            <GuiAutoComplete
              classes={{
                popper: classes.popper,
                option: classes.option,
              }}
              id="category"
              value={current.condition}
              name={`${name}.condition`}
              options={getOptions(current?.field?.fieldType?.toLowerCase())}
              size="small"
              autoHighlight
              getOptionLabel={(option) => {
                return option && option?.value ? option.label : '';
              }}
              // open={i === 0 || i === 1 ? false : undefined}
              renderInput={(params) => (
                <GuiTextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onBlur={handleBlur}
                  fullWidth
                  margin="dense"
                  label="Condition"
                  name="condition"
                  error={getError(`${name}.condition`)}
                  placeholder="Select Condition"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'off',
                  }}
                />
              )}
              onChange={(_, data) => {
                handleChange('condition', data);
              }}
            />
            <ErrorMessage
              render={(msg) => <div className="error-text rule-bulider-error">{msg}</div>}
              name={`sqlRules[${props.index}].condition`}
            />
          </div>
          <div className="type-field form-group sqlAutocomplete-input">
            <GuiAutoComplete
              classes={{
                popper: classes.popper,
                option: classes.option,
              }}
              id="category"
              value={current.type || {}}
              name={`${name}.type`}
              options={
                current?.field?.fieldName === 'ACCTNUM_FROM_CLIENT' ||
                hideValuesConditions?.includes(current?.condition?.value) ?
                  typeOptions2 :
                  typeOptions
              }
              size="small"
              autoHighlight
              getOptionLabel={(option) => {
                return option && option?.value ? option.label : '';
              }}
              renderInput={(params) => (
                <GuiTextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onBlur={handleBlur}
                  fullWidth
                  margin="dense"
                  label="Type"
                  name="type"
                  error={getError(`${name}.type`)}
                  placeholder="Select Type"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'off',
                  }}
                />
              )}
              onChange={(_, data) => {
                handleChange('type', data || {});
              }}
            />
            <ErrorMessage
              render={(msg) => <div className="error-text rule-bulider-error">{msg}</div>}
              name={`sqlRules[${props.index}].type`}
            />
          </div>
        </>
      )}
      {current.condition &&
      current?.type?.value &&
      current.condition.value &&
      current.condition.value !== 'BETWEEN' &&
      current.condition.value !== 'NOT BETWEEN' ? (
          <div
            className={`${
            current?.condition.value === 'isBlank' || current?.condition.value === 'isNotBlank' ?
              'col-lg-0' :
              'col-lg-2'
          } form-group`}
          >
            <GetFields
              type={current.field.fieldType?.toLowerCase()}
              fieldType={current?.type.value}
              rule={current}
              name={`${name}.value`}
              name1={`${name}.value1`}
              error={getError(`${name}.value`)}
              handleBlur={handleBlur}
              mappedFieldsData={mappedFieldsData || []}
              handleUpdateRule={handleChange}
            />
          </div>
        ) : (
          current.condition &&
        current?.type?.value && (
            <div className="value-field form-group">
              <GetFields
                type={current.field.fieldType?.toLowerCase()}
                rule={current}
                name={`${name}.value`}
                name1={`${name}.value1`}
                error={getError(`${name}.value`)}
                mappedFieldsData={mappedFieldsData || []}
                handleUpdateRule={handleChange}
              />
            </div>
          )
        )}
      {showSqlOutput && (
        <div className="output-field px-1">
          <div className="label-text  sql-output-label">SQL Output</div>
          <div className="sql-output-value" title={current.sqlValue}>
            {current.sqlValue}
          </div>
        </div>
      )}
      <div>
        <Tooltip title="Delete">
          <IconButton
            disabled={editExisting && !dmTempRecordAccess}
            onClick={() => handleDelete(current)}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

export default withField(SqlRuleBuilder);
